import { EventsService } from '@services/events/events.service';
import { StorageService } from '@services/storage/storage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VariablesService } from '@services/variables/variables.service';
import { inject, Component } from '@angular/core';
import { LANG } from '../../objects/lang';

@Component({
  selector: 'app-sac-purpose-dialog',
  templateUrl: './sac-purpose-dialog.component.html',
  styleUrls: ['./sac-purpose-dialog.component.scss']
})
export class SacPurposeDialogComponent {

  public variablesService = inject(VariablesService);
  public dialogRef = inject<MatDialogRef<SacPurposeDialogComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);
  private storageService = inject(StorageService);
  private eventsService = inject(EventsService);

  public purpose;
  public userdata: any;
  public currentLanguage: any;
  public lang = LANG;

  ngOnInit() {
    this.userdata = this.storageService.get(`userdata`);
    this.currentLanguage = this.storageService.get('language') || 'English';
    this.purpose = this.data.frType;
  }

  doAction() {
    this.dialogRef.close({
      data: this.purpose
    });
    const sacPuposeSelected = this.storageService.getFromSession('sac-purpose-selected');
    const sacInitiatedPayload = this.storageService.getFromSession('sac-initiated');
    if (!sacPuposeSelected) {
      this.storageService.addSessionData('sac-purpose-selected', { 'purpose': this.purpose });
      const payload = {
        eventName: 'cause_selection',
        page_name: this.variablesService.pageName,
        info_1: sacInitiatedPayload.info_1 || '',
        info_2: sacInitiatedPayload.info_2 || '',
        info_4: this.purpose,
        event_type: 'campaign'
      };
      this.eventsService.systemEventPush(payload);
    }
  }

  purposeSelectionEvent(data) {
    this.purpose = data;
    this.variablesService.purposeSelected = true;
  }

}
